import { render, staticRenderFns } from "./collectionDetail.vue?vue&type=template&id=5d7b19ad&"
import script from "./collectionDetail.vue?vue&type=script&lang=js&"
export * from "./collectionDetail.vue?vue&type=script&lang=js&"
import style0 from "./collectionDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports